import Dialog from "@/components/Dialog";
import Button from "@/components/Button";

interface RemoveBulkStudentsDialogProps {
  open: boolean;
  count: number;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  confirmLoading?: boolean;
}

export default function RemoveStudentsDialog({
  open,
  count,
  onClose,
  onConfirm,
  confirmLoading = false
}: RemoveBulkStudentsDialogProps) {
  return (
    <Dialog
      headline="Remove students"
      open={open}
      onClosed={onClose}
      actions={
        <>
          <Button variant="text" onClick={onClose} disabled={confirmLoading}>
            Cancel
          </Button>
          <Button
            variant="filled"
            theme="error"
            onClick={() => void onConfirm()}
            disabled={confirmLoading}
            testId="confirm-remove-bulk-students-button"
          >
            Remove
          </Button>
        </>
      }
    >
      <p className="text-body-medium text-sys-brand-on-surface">
        Remove <strong>{count}</strong> selected student{count !== 1 ? "s" : ""} from this list? This applies to all
        staff members and cannot be undone from this page.
      </p>
    </Dialog>
  );
}
